import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import Layout from "../Layout";
import Table from "antd/lib/table";
import Loader from "../loader";
import Add from "../../assets/images/Add.svg";
import { fetchAllNotificationdata, fetchUserRoledata } from "../../Redux/Api/fetch.api";
import { getallnotificationdata } from '../../Redux/Actions/NotificationAction';
import Edit_light from "../../assets/images/Edit_light.svg";
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { Tooltip } from 'antd';
import { getuserroleandmenu } from '../../Redux/Actions/UsersActions';
import NotAuthorised from "../Authentication/NotAuthorised";
import { useTranslation } from "react-i18next";
import Title from "../Title";
import { Breadcrumb } from "antd";

const NotificationIndex = () => {
    const { t } = useTranslation('notification');
    const { REACT_APP_DEFAULT_PAGESIZE } = process.env;
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [table, setTable] = useState([]);
    const [pageSize, setPageSize] = useState(REACT_APP_DEFAULT_PAGESIZE);
    const [options, setOptions] = useState({
        pagination: {
            current: 1,
            pageSize: pageSize,
            pageSizeOptions: ['50', '100'],
            showSizeChanger: true,
        },
    });
    //const [pageSize, setPageSize] = useState(10);
    //const [options, setOptions] = useState({ pagination: { current: 1 }, pageSize: pageSize });
    const [totalIndex, setCurrentIndex] = useState()
    const [pageData, setPageData] = useState({});
    const [total, setTotal] = useState()
    const [currentId, setCurrentId] = useState();
    const [isActive, setisActive] = useState(true);
    const loggedUserId = localStorage.getItem('UserId')
    const [roleId, setRoleId] = useState(null);
  
    useEffect(() => {
        getRoleDetails();
    }, []);

    useEffect(() => {
        if (roleId == 7 || roleId == 8) {
            getNotificationDetails();
        }
    }, [roleId])

    const handleChange = (pagination, sorter, current) => {
        const updatedOptions = { ...options, pagination };
        setOptions(updatedOptions);
        setPageData(updatedOptions)
    };

    const getNotificationDetails = () => {
        setLoading(true)
        fetchAllNotificationdata()
            .then(response => {
                dispatch(getallnotificationdata(response.data))
                setTable(response.data.data)
                setOptions({
                    ...options,
                    pagination: {
                        ...options.pagination,
                        total: response.data.count,
                    },
                });
                setLoading(false)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }

    const getRoleDetails = () => {
        if (loggedUserId == null) {
            history.push("/");
        }
        fetchUserRoledata(loggedUserId)
            .then(response => {
                dispatch(getuserroleandmenu(response.data))

                if (response.data.data.userRoleDetails[0].roleId)
                    setRoleId(response.data.data.userRoleDetails[0].roleId);
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const getFullDate = (date) => {
        const newDate = new Date(date);
        const returnDate = ((newDate.getMonth() > 8) ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1))) + '-' + ((newDate.getDate() > 9) ? newDate.getDate() : ('0' + newDate.getDate())) + '-' + newDate.getFullYear();
        const dateAndTime = date.split("T");
        const time = dateAndTime[1].split(":");
        const seconds = parseInt(time[2]);
        const newtime = time[0] + " : " + time[1] + " : " + seconds;
        const times = time[0] > 12 ? time[0] % 12 : time[0];
        const timeslatest = times < 9 ? ('0' + times) : times;
        const newtime1 = timeslatest + " : " + time[1] + " : " + seconds;
        if (time[0] && time[0] >= 12) {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime1 + " PM "
                returnDate + ", " + newtime1 + " PM "
            );
        } else {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime + " AM "
                returnDate + ", " + newtime + " AM "
            );
        }
    };

    const columns = [
        {
            title: t("SrNo"),
            dataIndex: "",
            render: (text, record, index) => { setCurrentIndex(`${(options.pagination.current === undefined ? 0 : options.pagination.current - 1) * 10 + index + 1}`); return `${(options.pagination.current === undefined ? 0 : options.pagination.current - 1) * 10 + index + 1}` },

        },

        {
            title: t("UserName"),
            dataIndex: "userName",
            className: "name-wrap"
        },

        {
            title: t("Company"),
            dataIndex: "companyName",
        },

        {
            title: t("Site"),
            dataIndex: "siteName",
        },

        {
            title: t("CreatedDate"),
            dataIndex: "createdDate",
            className: "date-wrap",
            render: (createdDate) => getFullDate(createdDate),

        },

        {
            title: t("ReadableDate"),
            dataIndex: "readableDate",
            className: "date-wrap",
            render: (readableDate) => {
                return readableDate ? getFullDate(readableDate) : "";
            },

        },


    ]

    return (
        <div>
            <Title title="Notifications"></Title>
            {roleId == null ? <Loader /> : roleId && roleId != 7 && roleId && roleId != 8 ? <NotAuthorised></NotAuthorised> :
                <>

                    <Layout>
                        <section className="Company_section common ">
                            <Toaster />
                            {loading ? <Loader /> : ''}
                            <div className="container notification-container">
                                <Breadcrumb style={{ margin: '20px 0 0 0   ', padding: '0px' }}
                                    itemRender={(route, params, routes, paths) => (
                                        route.path ? (
                                            <Link to={route.path}>
                                                {route.breadcrumbName}
                                            </Link>
                                        ) : (
                                            <span>{route.breadcrumbName}</span>
                                        )
                                    )}

                                    items={[
                                        {
                                            breadcrumbName: 'Dashboard',
                                            path: '/Dashboard',
                                        },
                                        {
                                            breadcrumbName: 'Settings',
                                            path: '',
                                        },
                                        {
                                            breadcrumbName: 'Notifications',
                                            path: '',
                                        }
                                    ]}
                                />

                                <div className="mt-4 w-100 position-relative wk-select">
                                    <h4 className="m-0">{t("Notifications")}</h4>
                                </div>

                                <div className="Viewer-table index--table position-relative common-table mb-4">

                                    <Table
                                        className='table-responsive antd--detail-table1'
                                        columns={columns}
                                        dataSource={table}
                                        pagination={options.pagination.total > REACT_APP_DEFAULT_PAGESIZE ? options.pagination : false}
                                        // pagination={options.pagination.total > 10 && totalIndex > 9 ? options.pagination : false}
                                        onChange={handleChange}
                                        // scroll={{ x: "450px" }}
                                        paginationTotalRows={total}

                                    />
                                </div>

                            </div>

                        </section>

                    </Layout>
                </>
            }
        </div>
    )
}
export default connect()(NotificationIndex);
